import { Plugin } from '@nuxt/types';
import Vue from 'vue';
import clickOutside from '~/directives/click-outside';

const directivesPlugin: Plugin = (context, inject) => {
  // Register directive globally using Vue
  Vue.directive('click-outside', clickOutside);
};

export default directivesPlugin;
